<template>
  <div class="card">
    <div class="card-body">
      <h4 class="header-title">{{ title }}</h4>
      <div class="d-flex align-items-center">
        <label for="service-select" class="service-select">Service Level</label>
        <select id="service-select" class="form-select" @change="handleChange">
          <option value="priority">Priority service</option>
          <option value="economy">Economy service</option>
        </select>
      </div>
      <b-table-simple responsive class="mb-0">
        <b-thead>
          <b-tr>
            <b-th>Max Weight</b-th>
            <b-th>Average Price (per 1 package)</b-th>
            <b-th>Change</b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr v-for="(line, index) in table" :key="index">
            <b-td>{{ line.weight }}</b-td>
            <b-td>{{ hasReportValue(line.currentPeriod) ? line.currentPeriod + ' kr' : 'Not enough data' }}</b-td>
            <b-td>
              <span v-if="!hasMeaningfulComparison(line.currentPeriod, line.previousPeriod, line.diff)" class="text-muted">—</span>
              <span v-else-if="isZeroReportValue(line.diff)" class="text-muted">0%</span>
              <span v-else-if="Number(line.diff) > 0" class="text-success me-2">
                <span class="mdi mdi-arrow-up-bold"></span>
                {{ line.diff }}%
              </span>
              <span v-else-if="Number(line.diff) < 0" class="text-danger me-2">
                <span class="mdi mdi-arrow-down-bold"></span>
                {{ line.diff }}%
              </span>
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
    </div>
  </div>
</template>

<script lang="ts">
import { hasReportValue, isZeroReportValue, hasMeaningfulComparison } from '@/utils/report-values'
import type { PeriodsDiff } from '@/typings/Shipments/PeriodsDiff'
import type { PricesInfo } from '@/typings/Shipments/PricesInfo'
import type { Filter } from '@/typings/Filter'
import { ref, watch, computed, defineComponent, type PropType } from 'vue'

export default defineComponent({
  props: {
    tableData: {
      type: Array as PropType<PeriodsDiff[]>,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    filters: {
      type: Object as PropType<Filter>,
      required: true,
    },
  },
  emits: ['update:serviceLevel'],
  setup(props, { emit }) {
    const tableDataLocal = ref<PeriodsDiff[]>([...props.tableData])

    watch(
      () => props.tableData,
      (newVal) => {
        tableDataLocal.value = [...newVal]
      },
      { immediate: true },
    )

    const table = computed<PricesInfo[]>(() =>
      tableDataLocal.value.map((item) => ({
        weight: item.name,
        currentPeriod: item.currentPeriod,
        previousPeriod: item.previousPeriod,
        diff: item.diff,
      })),
    )

    const handleChange = (event: Event) => {
      const target = event.target as HTMLSelectElement
      emit('update:serviceLevel', target.value)
    }

    return {
      hasReportValue,
      isZeroReportValue,
      hasMeaningfulComparison,
      table,
      handleChange,
    }
  },
})
</script>

<style scoped>
.service-select {
  margin-right: 10px;
  white-space: nowrap;
}
</style>
